import { Close } from "@mui/icons-material";
import { Avatar, Box, IconButton, Typography } from "@mui/material";

export const SwapyTeamSection = ({ title, maxSlots, type, assignedStaff = [], sxStyle, onRemoveStaff, itemsWithSuccess = [] }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        boxShadow: "none",
        border: "1px solid var(--fx-surface-border, #E2E8F0)",
        borderRadius: 2,
        ...sxStyle,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "var(--fx-surface-muted, #F1F5F9)",
          borderStartEndRadius: 2,
          borderStartStartRadius: 2,
          width: "100%",
          p: 1,
        }}
      >
        <Typography variant="h6" mb={1}>
          {title}
        </Typography>
      </Box>

      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          p: 2,
          border: "1px solid var(--fx-surface-border, #E2E8F0)",
          minHeight: "340px",
          width: "100%",
          borderRadius: 2,
        }}
      >
        {Array(maxSlots)
          .fill(0)
          .map((_, index) => {
            const staff = assignedStaff[index];
            const itemId = staff ? `worker-${staff.uid}` : null;
            const isSuccess = itemId && itemsWithSuccess.includes(itemId);
            const mustChange = Boolean(staff?.reassignment);

            return (
              <Box
                key={`slot-wrapper-${type}-${index}`}
                sx={{
                  width: "100%",
                  position: "relative",
                }}
              >
                <Box
                  data-swapy-slot={`workforce-slot-${type}-${index}`}
                  sx={{
                    width: "100%",
                    minHeight: "65px",
                    borderRadius: 2,
                    border: staff ? "none" : "2px dashed rgba(173, 173, 173, 0.6)",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {staff ? (
                    <Box
                      data-swapy-item={`worker-${staff.uid}`}
                      data-disabled={staff?.isAvailable ? "true" : "false"}
                      sx={{
                        width: "100%",
                        minHeight: "65px",
                        height: "auto",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        px: 1.5,
                        backgroundColor: mustChange ? "#fee2e2" : isSuccess ? "var(--fx-surface-muted, #F1F5F9)" : "var(--fx-surface-base, #FFFFFF)",
                        border: mustChange ? "2px solid #b91c1c" : isSuccess ? "3px solid #2e7d32" : "1px solid var(--fx-surface-borderstrong, #CBD5E1)",
                        color: mustChange ? "#b91c1c" : isSuccess ? "#2e7d32" : "inherit",
                        borderRadius: "8px",
                        cursor: staff?.isAvailable ? "not-allowed" : "grab",
                        position: "relative",
                        boxSizing: "border-box",
                      }}
                    >
                      <IconButton
                        size="small"
                        type="button"
                        data-swapy-no-drag
                        onPointerDown={(event) => {
                          event.preventDefault();
                          event.stopPropagation();
                        }}
                        onMouseDown={(event) => {
                          event.preventDefault();
                          event.stopPropagation();
                        }}
                        onTouchStart={(event) => {
                          event.stopPropagation();
                        }}
                        onClick={(event) => {
                          event.preventDefault();
                          event.stopPropagation();

                          onRemoveStaff?.({
                            staff,
                            type,
                            index,
                          });
                        }}
                        sx={{
                          position: "absolute",
                          top: -8,
                          right: -8,
                          width: 24,
                          height: 24,
                          zIndex: 20,
                          backgroundColor: "var(--fx-surface-base, #FFFFFF)",
                          border: "1px solid var(--fx-surface-border, #E2E8F0)",
                          boxShadow: 1,
                          pointerEvents: "auto",
                          "&:hover": {
                            backgroundColor: "var(--fx-surface-sunken, #F8FAFC)",
                          },
                        }}
                      >
                        <Close sx={{ fontSize: 16 }} />
                      </IconButton>

                      <Avatar
                        src={staff.avatar}
                        sx={{
                          width: 30,
                          height: 30,
                          flexShrink: 0,
                          fontSize: "1rem",
                        }}
                      >
                        {staff.firstName?.charAt(0)}
                      </Avatar>

                      <Box sx={{ minWidth: 0 }}>
                        <Typography
                          variant="caption"
                          sx={{
                            display: "block",
                            wordBreak: "break-word",
                            lineHeight: 1.2,
                            fontWeight: mustChange ? 800 : 400,
                            color: mustChange ? "#b91c1c" : "inherit",
                          }}
                        >
                          {staff.firstName} {staff.lastName}
                        </Typography>
                        {mustChange && (
                          <Typography variant="caption" sx={{ display: "block", color: "#b91c1c", fontWeight: 700, lineHeight: 1.15 }}>
                            Must be reassigned
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  ) : null}
                </Box>
              </Box>
            );
          })}
      </Box>
    </Box>
  );
};
